import profilIcon from './profilIcon.png';

export default profilIcon;
